import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.array.sort";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.number.constructor";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
import ApiService from '../../../services/apiService';
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { mapGetters, mapState } from 'vuex';
import customColorMixin from '@/mixins/customColor';
import iconsMixin from '../dtwin/state/bridge/iconsMixin';
import packetChartMixin from './packetChartMixin';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import isObject from 'lodash/isObject';
export default {
  name: 'CoreVirtualDeviceTab',
  mixins: [iconsMixin, customColorMixin, packetChartMixin],
  props: {
    dtwin: {
      type: Object,
      required: true
    },
    deviceTemplate: {
      type: Object,
      required: false,
      default: null
    },
    twinDataStates: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    bridgeReadMethod: {
      type: String,
      required: false,
      default: null
    },
    bridgeUpdateMethod: {
      type: String,
      required: false,
      default: null
    },
    bridgeCreateFields: {
      type: Array,
      required: true
    },
    bridgeCreateParameters: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    connectedBridge: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    bridgeManifest: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    hasTwinManagePermission: {
      type: Boolean,
      required: false,
      default: false
    },
    // do discourage the user from changing the device-type after it has been set
    // so compare dtwin.data.virtualDevice.deviceTypeId with this prop
    savedDeviceTypeId: {
      type: Number,
      required: false,
      default: null
    },
    // do discourage the user from changing the device-driver after it has been set
    // so compare dtwin.data.virtualDevice.deviceDriverId with this prop
    savedDeviceDriverId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      timeRange: {
        // from: 7 days before
        from: new Date(new Date() - 86400000 * 7) / 1000,
        to: new Date() / 1000,
        // does the time-range range to "NOW", i.e. should the packet-history be a live-viewer?
        timeRangeToNow: true,
        // distinguish whether USER picked a time-range or this is an auto-refresh
        isAutoRefresh: true
      },
      totalUplinkPacketCount: null,
      currentPacket: null,
      currentParsedPacket: null,
      panelsStartExpanded: false,
      deviceGroups: [],
      newDeviceGroup: '',
      isLoadingTotalCount: false,
      // in case the bridge has no update-method but a read-method, read the fields into here
      // otherwise "just print out the existing fields"
      deviceDataFromBridge: null,
      selectedBridge: null,
      bridgeTypes: [],
      deviceTypes: [],
      deviceDriver: null,
      selectedDeviceType: {},
      deviceTypeChangedPrompt: false,
      deviceTypeSyncPrompt: false,
      isUnlocked: false,
      downlinkFormValid: false,
      downlinkParameters: {},
      deviceDriversSearchResult: [],
      isSearchingDeviceDrivers: false,
      deviceDriversSearchInput: '',
      downlinksRenderCacheBuster: 0
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'language'])), mapGetters({
    isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
  })), {}, {
    isDeviceDriverActive: function isDeviceDriverActive() {
      return !this.isFeatureFlagEnabled('env_dispatcher_devicetype_fallback');
    },
    isCreatedByTemplate: function isCreatedByTemplate() {
      return !!this.deviceTemplate;
    },
    templateGroups: function templateGroups() {
      return this.deviceTemplate ? this.deviceTemplate.deviceMeta.groups : [];
    },
    predefinedDownlinks: function predefinedDownlinks() {
      if (this.bridgeManifest.displayName !== 'Firefly') {
        // no matter what the manifest says, predefined downlink selection currently only works for firefly
        return [];
      }

      var showPredefinedDownlinks = get(this.bridgeManifest, 'showPredefinedDownlinks');

      if (!showPredefinedDownlinks) {
        return [];
      }

      var driverVersions = get(this.deviceDriver, 'versions', []);

      if (!Array.isArray(driverVersions)) {
        driverVersions = [];
      }

      var activeDriverVersion = driverVersions.find(function (v) {
        return v.version === 'default';
      });
      var enumValues = get(this.downlinkMethodParameters, 'encoding.values', []);
      var deviceTypeDownlinks = get(this.selectedDeviceType, 'properties.downlinks');
      var deviceDriverDownlinks = get(activeDriverVersion, 'downlinks');
      var rawDownlinks = [];

      if (this.isDeviceDriverActive) {
        rawDownlinks = deviceDriverDownlinks || [];
      } else {
        rawDownlinks = deviceTypeDownlinks || [];
      }

      var downlinks = rawDownlinks.map(function (downlink) {
        if (!enumValues.includes(downlink.encoding)) {
          if (downlink.encoding !== 'base16') {
            return;
          }

          downlink.encoding = 'hex';
        }

        return downlink;
      }).filter(function (downlink) {
        return downlink;
      });
      return downlinks;
    },
    operationalStatus: function operationalStatus() {
      return {
        0: this.$i18n_t('NiotaClassic.Devices.form.unset'),
        1: this.$i18n_t('NiotaClassic.Devices.form.inTransit'),
        2: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$i18n_t('NiotaClassic.Devices.form.inOperation'),
        4: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      };
    },
    operationalStatusItems: function operationalStatusItems() {
      var _this = this;

      return Object.keys(this.operationalStatus).map(function (status) {
        return {
          text: _this.operationalStatus[status],
          value: status
        };
      });
    },
    rawState: function rawState() {
      return this.twinDataStates.find(function (state) {
        return state.key === '_raw';
      }) || {};
    },
    lastRawStateUpdate: function lastRawStateUpdate() {
      var isoDate = get(this.rawState, 'value.time');

      if (isoDate) {
        return new Date(isoDate);
      }

      return null;
    },
    getTypeNameOrDriverName: function getTypeNameOrDriverName() {
      return this.deviceDriverName || this.deviceTypeName;
    },
    deviceTypeId: function deviceTypeId() {
      return get(this.dtwin, 'data.virtualDevice.deviceTypeId');
    },
    deviceDriverId: function deviceDriverId() {
      return get(this.dtwin, 'data.virtualDevice.deviceDriverId', this.deviceTypeId);
    },
    deviceTypeName: function deviceTypeName() {
      var _this2 = this;

      if (this.deviceTypeId) {
        return (this.deviceTypes.find(function (dt) {
          return dt.id === get(_this2.dtwin, 'data.virtualDevice.deviceTypeId');
        }) || {}).title;
      }

      return null;
    },
    deviceDriverName: function deviceDriverName() {
      return this.deviceDriver ? this.deviceDriver.title : null;
    },
    deviceTypeHasParser: function deviceTypeHasParser() {
      return get(this.selectedDeviceType, 'parser.config') !== undefined;
    },
    deviceDriverHasDefaultParser: function deviceDriverHasDefaultParser() {
      var versions = get(this.deviceDriver, 'versions') || [];
      return versions.some(function (v) {
        return v.version === 'default';
      });
    },
    downlinkMethodParameters: function downlinkMethodParameters() {
      return get(this.bridgeManifest, 'commands.instance.sendPacket.parameters') || {};
    },
    downlinkMethodFields: function downlinkMethodFields() {
      var _this3 = this;

      var keys = Object.keys(this.downlinkMethodParameters).filter(function (k) {
        return k !== 'deviceId';
      });
      return keys.sort(function (a, b) {
        var orderIdxA = get(_this3.downlinkMethodParameters, "[".concat(a, "].orderIdx")) || 0;
        var orderIdxB = get(_this3.downlinkMethodParameters, "[".concat(b, "].orderIdx")) || 0;

        if (orderIdxA < orderIdxB) {
          return -1;
        }

        if (orderIdxA > orderIdxB) {
          return 1;
        }

        return a.localeCompare(b);
      });
    },
    packetsMetricsDataComp: function packetsMetricsDataComp() {
      return {
        common: {
          labels: this.packetMetricsData.common.labels
        },
        individual: [{
          color: this.customColor,
          label: this.$i18n_t('DigitalTwin.VirtualDevice.details.latestTimeRange'),
          data: this.packetMetricsData.individual[0].data,
          labels: this.packetMetricsData.individual[0].labels
        }, {
          color: '#aaa',
          label: this.$i18n_t('DigitalTwin.VirtualDevice.details.previousTimeRange'),
          data: this.packetMetricsData.individual[1].data,
          labels: this.packetMetricsData.individual[1].labels
        }]
      };
    },
    bridgeOutputFieldKeys: function bridgeOutputFieldKeys() {
      var _this4 = this;

      if (!this.bridgeUpdateMethod && this.bridgeReadMethod) {
        return this.bridgeCreateFields.map(function (configKey) {
          if ((_this4.deviceDataFromBridge || {})[configKey]) {
            return configKey;
          }

          return null;
        }).filter(function (f) {
          return f;
        });
      }

      return this.bridgeCreateFields;
    },
    useExternalData: function useExternalData() {
      return get(this.bridgeManifest, 'functionScope.useExternalDataOnly', false);
    }
  }),
  watch: {
    deviceTypeName: function deviceTypeName() {
      this.fetchDeviceDependentData();
    },
    deviceDriverName: function deviceDriverName() {
      this.fetchDeviceDependentData();
    },
    twinDataStates: debounce(function () {
      // to enable a "live-packet-viewer", listen to updates of the twin-data-states
      // if there is an update, and the selected timerange is "up to now", forward an event to
      // the packet-history-viewer that will evaluate whether to perform a refresh
      if (this.timeRange.timeRangeToNow) {
        this.timeRange = _objectSpread(_objectSpread({}, this.timeRange), {}, {
          isAutoRefresh: true,
          to: new Date() / 1000
        }); // this.fetchTotalPacketCount();
      }
    }, 1000),
    currentPacket: function currentPacket() {
      this.parsePacket();
    },
    dtwin: debounce(function () {
      this.setupInitialVDevice();
      var doNotParsePacket = false;
      this.fetchDeviceDependentData(doNotParsePacket);
    }, 1000),
    bridgeReadMethod: function bridgeReadMethod() {
      this.fetchDeviceDependentData();
    },
    deviceDriversSearchInput: {
      handler: function () {
        var _handler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(searchValue) {
          var result;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  this.isSearchingDeviceDrivers = true;
                  _context.next = 4;
                  return ApiService.virtualDeviceDrivers.fetch({
                    search: searchValue
                  });

                case 4:
                  result = _context.sent;
                  this.deviceDriversSearchResult = result.deviceDrivers;

                case 6:
                  _context.prev = 6;
                  this.isSearchingDeviceDrivers = false;
                  return _context.finish(6);

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[0,, 6, 9]]);
        }));

        function handler(_x) {
          return _handler.apply(this, arguments);
        }

        return handler;
      }(),
      immediate: true
    },
    deviceDriverId: {
      handler: function () {
        var _handler2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  this.fetchDeviceDriver();
                  this.parsePacket();

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function handler() {
          return _handler2.apply(this, arguments);
        }

        return handler;
      }(),
      immediate: true
    },
    deviceDriverHasDefaultParser: function deviceDriverHasDefaultParser() {
      this.parsePacket();
    },
    deviceTypeHasParser: function deviceTypeHasParser() {
      this.parsePacket();
    },
    bridgeManifest: function bridgeManifest() {
      this.parsePacket();
    }
  },
  created: function created() {
    this.setupInitialVDevice();
  },
  mounted: function mounted() {
    this.fetchDeviceTypes();
    this.fetchDeviceGroups(); // this.fetchTotalPacketCount(); // Get Number of all packets.

    this.fetchPacketCountHistory(); // Get Packet History Chart Data

    this.fetchDeviceDependentData();
  },
  methods: {
    get: get,
    clickRowHandler: function clickRowHandler(item) {
      this.currentPacket = item;
    },
    selectPredefinedDownlink: function selectPredefinedDownlink(item) {
      if (item === undefined) {
        // was cleared
        this.downlinkParameters['payload'] = null;
        this.downlinkParameters['encoding'] = 'utf8';
        this.downlinkParameters['port'] = 0;
        this.downlinkParameters['eui'] = null;
        return;
      }

      var download = item || {};
      this.downlinkParameters['payload'] = download.payload || '';
      this.downlinkParameters['encoding'] = download.encoding || 'hex';
      this.downlinkParameters['port'] = parseInt(download.port, 10) || 1;
      this.downlinkParameters['eui'] = get(this.dtwin, 'properties.bridge.deviceData.device_id') || '';
      this.downlinksRenderCacheBuster += 1;
    },
    setupInitialVDevice: function setupInitialVDevice() {
      if (!get(this.dtwin, 'properties.bridge')) {
        this.dtwin.properties = _objectSpread(_objectSpread({}, get(this.dtwin, 'properties') || {}), {}, {
          bridge: {
            deviceData: {}
          }
        });
      }

      if (!get(this.dtwin, 'data.virtualDevice')) {
        this.dtwin.data = _objectSpread(_objectSpread({}, get(this.dtwin, 'data') || {}), {}, {
          virtualDevice: {}
        });
      }
    },
    deviceConfigChanged: function deviceConfigChanged() {
      // force a UI-refresh of the fields (dependent config fields)
      this.dtwin = _objectSpread(_objectSpread({}, this.dtwin), {}, {
        properties: cloneDeep(this.dtwin.properties)
      });
    },
    noop: function noop() {
      // eslint-disable-next-line no-console
      console.debug('no op');
    },
    setTimeRange: function setTimeRange(data) {
      var timeRangeToNow = new Date() - new Date(data.to * 1000) < 60 * 1000;
      this.currentPacket = null;
      this.timeRange = {
        from: data.from,
        to: data.to,
        timeRangeToNow: timeRangeToNow,
        isAutoRefresh: timeRangeToNow
      };
      this.fetchPacketCountHistory();
    },
    fetchPacketCountHistory: function fetchPacketCountHistory() {
      var _this5 = this;

      if (!this.dtwin.id || !this.rawState.id || this.isLoadingPacketMetrics) {
        return;
      }

      this.isLoadingPacketMetrics = true;
      var lclTimeFrom;

      if (!this.timeRange.from) {
        lclTimeFrom = new Date(new Date() - 86400000 * 62) / 1000;
      } else {
        lclTimeFrom = this.timeRange.from;
      }

      var rangeStart = new Date(lclTimeFrom * 1000);
      var interval = new Date(this.timeRange.to * 1000) - rangeStart;
      var priorRangeStart = new Date(rangeStart - interval); // note: the default options of time-range-picker may be 1min short of the full interval,
      // i.e. "yesterday" picks 12:00 AM ... to ... 11:59 PM
      // so subtract a minute if interval is greater than a day, to be sure

      var oneDay = (86400 - 60) * 1000;
      var oneHour = 3600 * 1000;
      var fifteenMinutes = 900 * 1000;
      var duration = interval >= oneDay * 2 ? '1d' : interval >= oneHour * 2 ? '1h' : interval >= fifteenMinutes * 2 ? '15m' : '5m'; // fetch the current interval, as well as the "parallel" history exactly 1 interval prior

      Promise.all([ApiService.virtualDevicePacketStatistics(this, this.dtwin.id, rangeStart, new Date(this.timeRange.to * 1000), duration), ApiService.virtualDevicePacketStatistics(this, this.dtwin.id, priorRangeStart, rangeStart, duration)]).then(function (data) {
        _this5.preparePacketMetricsData(data[0].total, data[1].total, 'packetMetricsOptions', 'packetMetricsData', true);

        _this5.isLoadingPacketMetrics = false;
      }).catch(function (error) {
        console.error(error);
      });
    },
    relativeTime: function relativeTime(date) {
      if (date) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
        return moment(date).fromNow();
      }

      return '-';
    },
    fetchDeviceTypes: function fetchDeviceTypes() {
      var _this6 = this;

      NiotaClassicApiService.deviceTypesGetPlain().then(function (res) {
        _this6.deviceTypes = res.data.devicetypes;
      }).catch(function (error) {
        _this6.$snack(_this6.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');

        console.error(error);
      });
    },
    fetchDeviceDriver: function () {
      var _fetchDeviceDriver = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.deviceDriverId) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                _context3.next = 4;
                return ApiService.virtualDeviceDrivers.fetchOneById(this.deviceDriverId);

              case 4:
                this.deviceDriver = _context3.sent;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchDeviceDriver() {
        return _fetchDeviceDriver.apply(this, arguments);
      }

      return fetchDeviceDriver;
    }(),
    fetchDeviceDependentData: function fetchDeviceDependentData() {
      var _this7 = this;

      if (this.deviceTypeName) {
        NiotaClassicApiService.deviceTypeGetDetails(this.dtwin.data.virtualDevice.deviceTypeId).then(function (res) {
          _this7.selectedDeviceType = res.data.devicetype;
        }).catch(function (error) {
          _this7.$snack(_this7.$i18n_t('NiotaClassic.DeviceTypes.snacks.fetchDetailsFailed'), 'error');

          console.error(error);
        });
      } // in case the bridge has no update, check if we shall show readonly data here by fetching the
      // current config straight from the bridge


      if (!this.deviceDataFromBridge && get(this.dtwin, 'properties.bridge.deviceData.device_id') && (this.useExternalData || this.bridgeReadMethod && !this.bridgeUpdateMethod)) {
        // Dirty hack because i don't know what the ~1000 Lines of code here are doing...
        // Tbh. this is not how vue should be used....
        // 1000 Lines in ONE FILE!
        if (!this.bridgeReadMethod) {
          return;
        }

        var parameterNames = Object.keys(get(this.bridgeManifest, "commands.instance.".concat(this.bridgeReadMethod, ".parameters"), {}));
        var parameters = {};

        if (parameterNames.length >= 1) {
          parameters[parameterNames[0]] = get(this.dtwin, 'properties.bridge.deviceData.device_id');
        }

        ApiService.bridgeCommand(this.connectedBridge.id, this.bridgeReadMethod, parameters).then(function (result) {
          if (!result.error && result.data) {
            _this7.deviceDataFromBridge = result.data;

            if (_this7.useExternalData) {
              if (_this7.connectedBridge.type === 'bridge-wireless-mbus-decoder' && _this7.dtwin.properties.bridge.deviceData.key) {
                // copy key from deviceData as it cannot be provided from remote system
                _this7.deviceDataFromBridge.key = _this7.dtwin.properties.bridge.deviceData.key;
              }

              if (!isEqual(_this7.dtwin.properties.bridge.deviceData, result.data)) {
                _this7.dtwin.properties.bridge.deviceData = result.data;

                _this7.$snack(_this7.$i18n_t('DigitalTwin.VirtualDevice.deviceDataHasBeenChanged', {
                  connectorName: _this7.connectedBridge.name
                }), 'info');
              }
            }
          } else {
            _this7.$snack(get(result, 'data.error') || result.errorMessage, 'error');
          }
        }).catch(function (error) {
          if (error.response && _this7.$i18n_t("Error.".concat(error.response.data.message))) {
            _this7.$snack(_this7.$i18n_t("Error.".concat(error.response.data.message)), 'error');
          } else {
            _this7.$snack(_this7.$i18n_t('Common.digitalTwins.twinCreatedFail'), 'error');
          }
        });
      }
    },
    parsePacket: function parsePacket() {
      var _this8 = this;

      if (!(this.deviceDriverHasDefaultParser || this.deviceTypeHasParser || this.deviceDriverId)) {
        return;
      }

      var payload = get(this.currentPacket, "value.".concat(get(this.bridgeManifest, 'virtualDevice.deviceTypes.packetParser.valueMapping.payload')));

      if (!payload) {
        return;
      } // Payload must not be a HEX String, it can be as well an object
      // take care of that:


      if (isObject(payload)) {
        this.currentParsedPacket = payload;
        return;
      } // For legacy LoRaWAN parser in N1 we need a port


      var port = null;

      if (get(this.bridgeManifest, 'virtualDevice.deviceTypes.packetParser.valueMapping.port')) {
        port = get(this.currentPacket, "value.".concat(this.bridgeManifest.virtualDevice.deviceTypes.packetParser.valueMapping.port));
      } // If the port is unset, we give it a default: 1


      if (!port) {
        port = 1;
      }

      var twinId = -1;

      if (this.dtwin.id) {
        twinId = this.dtwin.id;
      }

      var dataTimestamp;

      if (this.currentPacket.value.timestamp) {
        dataTimestamp = this.currentPacket.value.timestamp;
      }

      var parserPayload = {
        payload: payload,
        meta: {
          device_id: twinId,
          device_driver_id: this.deviceDriverId,
          device_type_id: this.deviceTypeId,
          source_time: dataTimestamp,
          lora: {
            fport: port
          }
        }
      };
      var parserMethod = this.isDeviceDriverActive ? ApiService.deviceDriverParsePayload(this.deviceDriverId, parserPayload) : ApiService.virtualDeviceDeviceTypesParsePayloadN1(this.deviceDriverId, parserPayload);
      parserMethod.then(function (res) {
        var error = get(res, 'error');
        var parsedPacket = get(res, 'parsed', get(res, 'result', error));

        if (parsedPacket.__niotix_internal_logs) {
          delete parsedPacket.__niotix_internal_logs;
        }

        _this8.currentParsedPacket = parsedPacket;
      }).catch(function () {
        _this8.$snack(_this8.$i18n_t('DigitalTwin.VirtualDevice.parser.internalServerError'), 'error');
      });
    },
    fetchTotalPacketCount: function fetchTotalPacketCount() {
      return; // Taken out by MWa because VDs with very high amount of packets (like half a million)
      // kills the influx, it causes OOM Outages on cubbage.aws
      // if (!this.dtwin.id || !this.rawState.id || this.isLoadingTotalCount) {
      //   return;
      // }
      // this.isLoadingTotalCount = true;
      // const timeRangeQueryItems = {
      //   and: [
      //     { path: '_time', operator: 'gte', value: this.dtwin.createdAt },
      //     { path: '_time', operator: 'lte', value: new Date().toISOString() },
      //   ],
      // };
      // ApiService.influxStatesInfluxSearch(this, [this.dtwin.id], [this.rawState.id], timeRangeQueryItems, 0, 1, [
      //   { path: '_time', direction: 'DESC' },
      // ])
      //   .then((data) => {
      //     this.totalUplinkPacketCount = data.totalCount;
      //   })
      //   .catch((error) => { console.error(error); })
      //   .finally(() => {
      //     this.isLoadingTotalCount = false;
      //   });
    },
    fetchDeviceGroups: function fetchDeviceGroups() {
      var _this9 = this;

      ApiService.virtualDeviceFetchGroups().then(function (res) {
        _this9.deviceGroups = res.groupList || [];

        if (_this9.isCreatedByTemplate) {
          _this9.deviceGroups = _this9.deviceGroups.map(function (group) {
            return {
              text: group,
              value: group,
              disabled: _this9.templateGroups.includes(group)
            };
          });
        }
      }).catch(function (error) {
        _this9.$snack(_this9.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');

        console.error(error);
      });
    },
    addNewDeviceGroup: function addNewDeviceGroup() {
      var _this10 = this;

      var matchingGroup = this.deviceGroups.find(function (g) {
        var currentValue = _this10.isCreatedByTemplate ? g.value : g;
        return currentValue.toLowerCase().trim() === _this10.newDeviceGroup.toLowerCase().trim();
      });

      if (!matchingGroup) {
        matchingGroup = this.newDeviceGroup.trim();
        this.deviceGroups = [].concat(_toConsumableArray(this.deviceGroups), [this.isCreatedByTemplate ? {
          text: matchingGroup,
          value: matchingGroup
        } : matchingGroup]);
      }

      this.dtwin.properties.groups = [].concat(_toConsumableArray(this.dtwin.properties.groups), [matchingGroup]);
      this.newDeviceGroup = '';
    },
    sendDownlinkPacket: function sendDownlinkPacket() {
      var _this11 = this;

      ApiService.bridgeCommand(this.dtwin.properties.bridge.configId, 'sendPacket', _objectSpread(_objectSpread({}, this.downlinkParameters), {}, {
        deviceId: this.dtwin.properties.bridge.deviceData.device_id
      })).then(function (res) {
        if (res.error === false) {
          _this11.$snack(_this11.$i18n_t('NiotaClassic.Devices.snacks.sentDownlink'), 'success');
        } else {
          throw {
            response: {
              data: {
                err: get(res, 'data[0].message') || res.data || res.errorMessage
              }
            }
          };
        }
      }).catch(function (error) {
        var apiError = get(error, 'response.data.err') || error;

        _this11.$snack(apiError || _this11.$i18n_t('NiotaClassic.Devices.snacks.failedDownlink'), 'error');
      });
    },
    getDependsOnFieldValue: function getDependsOnFieldValue(createFields, currentField, deviceData) {
      var dependsOnFieldName = get(createFields[currentField], 'dependsOnField');

      if (!dependsOnFieldName) {
        return null;
      }

      return deviceData[dependsOnFieldName];
    },
    restrictCharacters: function restrictCharacters(event) {
      if (event.key === ',' || event.key === ';') {
        event.preventDefault();
      }
    },
    changeActiveDeviceDriverId: function () {
      var _changeActiveDeviceDriverId = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(selected) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.isDeviceDriverActive) {
                  this.$emit('change-device-driver', selected);
                } else {
                  this.$emit('change-device-type', selected);
                }

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function changeActiveDeviceDriverId(_x2) {
        return _changeActiveDeviceDriverId.apply(this, arguments);
      }

      return changeActiveDeviceDriverId;
    }()
  }
};